/**
 * QuickTransactionActions — 4 prominent buttons for the most common transactions.
 * Navigates to /dashboard/vouchers?action=<type> which auto-opens the correct form.
 */
import { useNavigate } from 'react-router-dom';
import { TrendDown, TrendUp, ArrowsLeftRight, BookOpen } from '@phosphor-icons/react';

const TX = [
  {
    key: 'expense',
    label: 'Record Expense',
    desc: 'Cash/Bank paid out (rent, fuel, supplies…)',
    icon: TrendDown,
    color: 'from-red-500/20 to-red-500/5 border-red-500/30 hover:border-red-500/60',
    iconColor: 'text-red-500',
    href: '/dashboard/vouchers?action=expense',
  },
  {
    key: 'income',
    label: 'Record Income',
    desc: 'Cash/Bank received (sale, fee, refund)',
    icon: TrendUp,
    color: 'from-emerald-500/20 to-emerald-500/5 border-emerald-500/30 hover:border-emerald-500/60',
    iconColor: 'text-emerald-500',
    href: '/dashboard/vouchers?action=income',
  },
  {
    key: 'transfer',
    label: 'Transfer',
    desc: 'Bank → Bank, Cash → Bank, owner contributions',
    icon: ArrowsLeftRight,
    color: 'from-blue-500/20 to-blue-500/5 border-blue-500/30 hover:border-blue-500/60',
    iconColor: 'text-blue-500',
    href: '/dashboard/vouchers?action=transfer',
  },
  {
    key: 'adjustment',
    label: 'Journal Adjustment',
    desc: 'Non-cash entries (depreciation, accrual…)',
    icon: BookOpen,
    color: 'from-amber-500/20 to-amber-500/5 border-amber-500/30 hover:border-amber-500/60',
    iconColor: 'text-amber-500',
    href: '/dashboard/accounts/journal',
  },
];

export default function QuickTransactionActions({ compact = false }) {
  const navigate = useNavigate();
  return (
    <div
      className={`grid gap-3 ${compact ? 'grid-cols-2 md:grid-cols-4' : 'grid-cols-2 md:grid-cols-4'}`}
      data-testid="quick-actions"
    >
      {TX.map((t) => {
        const Icon = t.icon;
        return (
          <button
            key={t.key}
            onClick={() => navigate(t.href)}
            data-testid={`quick-action-${t.key}`}
            className={`bg-gradient-to-br ${t.color} border rounded-xl p-4 text-left transition-all hover:shadow-lg active:scale-95`}
          >
            <Icon size={28} weight="duotone" className={`${t.iconColor} mb-2`} />
            <div className="font-semibold text-sm">{t.label}</div>
            <div className="text-[11px] text-muted-foreground mt-0.5 leading-tight">{t.desc}</div>
          </button>
        );
      })}
    </div>
  );
}
